import { useEffect, useRef } from "react";
import Hls from "hls.js";
import { VideoCamera, VideoCameraSlash } from "@phosphor-icons/react";

export default function CameraFeed({ type, url }) {
  const videoRef = useRef(null);

  useEffect(() => {
    if (type !== "hls" || !url || !videoRef.current) return;
    const video = videoRef.current;
    let hls;
    if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = url;
    } else if (Hls.isSupported()) {
      hls = new Hls({ lowLatencyMode: true });
      hls.loadSource(url);
      hls.attachMedia(video);
    }
    return () => { if (hls) hls.destroy(); };
  }, [type, url]);

  if (type === "none" || !url) {
    return (
      <div className="w-full h-full flex flex-col items-center justify-center text-muted-foreground bg-black/40">
        <VideoCameraSlash size={28} />
        <span className="text-[10px] tracking-widest uppercase mt-1">Sin cámara</span>
      </div>
    );
  }

  if (type === "iframe") {
    return <iframe title="cam" src={url} className="w-full h-full border-0" allow="autoplay; fullscreen" />;
  }

  return (
    <div className="relative w-full h-full bg-black">
      <video ref={videoRef} autoPlay muted playsInline className="w-full h-full object-cover" />
      <span className="absolute top-2 left-2 flex items-center gap-1 text-[10px] tracking-widest uppercase text-padel-green bg-black/60 px-2 py-0.5">
        <VideoCamera size={12} weight="fill" /> Live
      </span>
    </div>
  );
}
